module.exports = __webpack_public_path__ + "img/12pts345.c35e7e47.png";